import { render } from "./FormEditor.vue?vue&type=template&id=76622617&scoped=true"
import script from "./FormEditor.vue?vue&type=script&lang=js"
export * from "./FormEditor.vue?vue&type=script&lang=js"

import "./FormEditor.vue?vue&type=style&index=0&id=76622617&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76622617"]])

export default __exports__